/**
 * Generated by orval v6.12.1 🍺
 * Do not edit manually.
 * Platz API
 * Platz API boi
 * OpenAPI spec version: 2.0
 */

export type SourceLocationType =
  (typeof SourceLocationType)[keyof typeof SourceLocationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceLocationType = {
  openai_chat: "openai_chat",
  youtube: "youtube",
  googled_lyrics: "googled_lyrics",
  text_page: "text_page",
} as const;
